import OnboardingDuration from './OnboardingDuration'

export default OnboardingDuration
// eslint-disable-next-line import/export
export * from './OnboardingDuration'
